import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";import { getStorage } from 'firebase/storage';
const firebaseConfig = {
  apiKey: "AIzaSyBQatfRaQZ407V6dGzTUyEXbTWBEj2sU6c",
  authDomain: "auto-fb-ccb6f.firebaseapp.com",
  projectId: "auto-fb-ccb6f",
  storageBucket: "auto-fb-ccb6f.firebasestorage.app",
  messagingSenderId: "1057680330984",
  appId: "1:1057680330984:web:970745248f3841165f795d",
  measurementId: "G-0DP54L07F8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Segunda instancia para crear usuarios sin afectar la sesión activa
const secondaryApp = initializeApp(firebaseConfig, 'Secondary');
export const secondaryAuth = getAuth(secondaryApp);